module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/124-vatican-city-bbba6c30f144a93162d12c342f6a3e17.svg";